import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { KeyRound } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PasswordResetPage = () => {
  const [formData, setFormData] = useState({ email: "", newPassword: "", secretKey: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password-direct`, {
        email: formData.email,
        new_password: formData.newPassword,
        secret_key: formData.secretKey
      });
      toast.success("تم تغيير كلمة المرور بنجاح!");
      navigate("/login");
    } catch (error) {
      toast.error(error.response?.data?.detail || "حدث خطأ");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card animate-fade-in">
        <div className="login-logo">
          <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
            <KeyRound className="w-8 h-8 text-white" />
          </div>
          <h1>إعادة تعيين كلمة المرور</h1>
          <p>أدخل بيانات حسابك ومفتاح الأمان</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">البريد الإلكتروني</label>
            <input
              type="email"
              className="form-input"
              placeholder="example@clinic.com"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">كلمة المرور الجديدة</label>
            <input
              type="password"
              className="form-input"
              placeholder="••••••••"
              value={formData.newPassword}
              onChange={(e) => setFormData({ ...formData, newPassword: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">مفتاح الأمان</label>
            <input
              type="password"
              className="form-input"
              placeholder="أدخل مفتاح الأمان"
              value={formData.secretKey}
              onChange={(e) => setFormData({ ...formData, secretKey: e.target.value })}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-full mt-6"
            disabled={loading}
          >
            {loading ? "جاري التحميل..." : "تغيير كلمة المرور"}
          </button>
        </form>

        <Link to="/login" className="block text-center mt-6 text-blue-500 hover:text-blue-600 text-sm">
          العودة لتسجيل الدخول
        </Link>
      </div>
    </div>
  );
};

export default PasswordResetPage;
